export const routerPushAndScroll = (router: any, route: string) => {
  router.push(route).then(() => window.scrollTo(0, 0));
};
